"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const AuthBox_1 = require("./AuthBox");
require("./AuthBoxLayout.css");
function AuthBoxLayout(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement("div", Object.assign({ id: "auth-box" }, props), children));
}
exports.default = AuthBoxLayout;
AuthBoxLayout.Header = function AuthBoxLayoutHeader(_a) {
    var { title, alternative = null, children } = _a, props = __rest(_a, ["title", "alternative", "children"]);
    const { noHeader } = (0, AuthBox_1.useAuthBoxContext)();
    if (noHeader) {
        return null;
    }
    return (React.createElement("div", Object.assign({ id: "auth-box-header" }, props),
        React.createElement("div", { className: "header-row" },
            React.createElement("h3", null, title),
            React.createElement("div", { className: "alternative" }, alternative)),
        children));
};
AuthBoxLayout.Messages = function AuthBoxLayoutMessages(_a) {
    var { messages } = _a, props = __rest(_a, ["messages"]);
    React.createElement("div", Object.assign({ id: "auth-box-messages" }, props), messages.map((message, i) => {
        return (React.createElement("div", { key: i, className: "auth-box-message" }, message.message));
    }));
};
AuthBoxLayout.Form = function AuthBoxLayoutForm(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement("div", Object.assign({ id: "auth-box-form" }, props), children));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXV0aEJveExheW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91aS9BdXRoQm94TGF5b3V0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBK0I7QUFDL0IsdUNBQThDO0FBQzlDLCtCQUE2QjtBQVc3QixTQUF3QixhQUFhLENBQUMsRUFBcUM7UUFBckMsRUFBRSxRQUFRLE9BQTJCLEVBQXRCLEtBQUssY0FBcEIsWUFBc0IsQ0FBRjtJQUN4RCxPQUFPLENBQ0wsMkNBQUssRUFBRSxFQUFDLFVBQVUsSUFBSyxLQUFLLEdBQ3pCLFFBQVEsQ0FDTCxDQUNQLENBQUM7QUFDSixDQUFDO0FBTkQsZ0NBTUM7QUFPRCxhQUFhLENBQUMsTUFBTSxHQUFHLFNBQVMsbUJBQW1CLENBQUMsRUFLekI7UUFMeUIsRUFDbEQsS0FBSyxFQUNMLFdBQVcsR0FBRyxJQUFJLEVBQ2xCLFFBQVEsT0FFaUIsRUFEdEIsS0FBSyxjQUowQyxvQ0FLbkQsQ0FEUztJQUVSLE1BQU0sRUFBRSxRQUFRLEVBQUUsR0FBRyxJQUFBLDJCQUFpQixHQUFFLENBQUM7SUFDekMsSUFBSSxRQUFRLEVBQUU7UUFDWixPQUFPLElBQUksQ0FBQztLQUNiO0lBQ0QsT0FBTyxDQUNMLDJDQUFLLEVBQUUsRUFBQyxpQkFBaUIsSUFBSyxLQUFLO1FBQ2pDLDZCQUFLLFNBQVMsRUFBQyxZQUFZO1lBQ3pCLGdDQUFLLEtBQUssQ0FBTTtZQUNoQiw2QkFBSyxTQUFTLEVBQUMsYUFBYSxJQUFFLFdBQVcsQ0FBTyxDQUM1QztRQUNMLFFBQVEsQ0FDTCxDQUNQLENBQUM7QUFDSixDQUFDLENBQUM7QUFVRixhQUFhLENBQUMsUUFBUSxHQUFHLFNBQVMscUJBQXFCLENBQUMsRUFHakM7UUFIaUMsRUFDdEQsUUFBUSxPQUVhLEVBRGxCLEtBQUssY0FGOEMsWUFHdkQsQ0FEUztJQUVSLDJDQUFLLEVBQUUsRUFBQyxtQkFBbUIsSUFBSyxLQUFLLEdBQ2xDLFFBQVEsQ0FBQyxHQUFHLENBQUMsQ0FBQyxPQUFPLEVBQUUsQ0FBQyxFQUFFLEVBQUU7UUFDM0IsT0FBTyxDQUNMLDZCQUFLLEdBQUcsRUFBRSxDQUFDLEVBQUUsU0FBUyxFQUFDLGtCQUFrQixJQUN0QyxPQUFPLENBQUMsT0FBTyxDQUNaLENBQ1AsQ0FBQztJQUNKLENBQUMsQ0FBQyxDQUNFLENBQUM7QUFDVCxDQUFDLENBQUM7QUFFRixhQUFhLENBQUMsSUFBSSxHQUFHLFNBQVMsaUJBQWlCLENBQUMsRUFHaEM7UUFIZ0MsRUFDOUMsUUFBUSxPQUVNLEVBRFgsS0FBSyxjQUZzQyxZQUcvQyxDQURTO0lBRVIsT0FBTyxDQUNMLDJDQUFLLEVBQUUsRUFBQyxlQUFlLElBQUssS0FBSyxHQUM5QixRQUFRLENBQ0wsQ0FDUCxDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=